import {Link} from "react-router-dom";
import SwiperBanner from "../components/SwiperBanner";
import PageHeader from "../components/PageHeader";
import {useSelector, useDispatch} from "react-redux";
import {numberWithCommas} from "../utils/math";
import { NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState, useMemo } from "react";
import { getbalance, logout, bannerlist, bannerpopup, createautoline } from "../store/user";
import { WEBCASINO, WEBNAME, LINE_TOKEN } from "../store/config";
import Popup from '../components/Popup'
import Popfix from '../components/PopupFix'

function Home() {
    const dispatch = useDispatch()
    const navigate = useNavigate()

  useEffect(() => {

    const liff = window.liff;
    
    const fetchData = async () => {
      await liff.init({ liffId: `${LINE_TOKEN}` }).catch(err=>{throw err});
      if (liff.isLoggedIn()) {
        let getProfile = await liff.getProfile();
       
        //const action = memberActions.handlelineid({name:getProfile.displayName,lineid:getProfile.userId},navigate,"/play/lotto");
        //dispatch(action);
        dispatch(createautoline({name:getProfile.displayName,lineid:getProfile.userId, navigate, link:'/lotto'}))
      }else{
        liff.login();
      }
      /*const action = memberActions.handlelineid({name:"testline",lineid:"testline"},history);
      dispatch(action);*/
    }
   //dispatch(createautoline({name:"TESTAPP1",lineid:"Ufed673455a68862c4273a2dc3d03b17f", navigate, link:'/lotto'}))
    dispatch(createautoline({name:"ooddoo",lineid:"Uae5bb93c4b4bce990408e21c801eb26f", navigate, link:'/lotto'}))
   
   // dispatch(action);
    // call the function
   // fetchData()
   
  }, []);
    

    return (
        <div>
        <div style={{height:80}}></div>
        <div className="ring">LOADING
    <span className='span1'></span>
  </div>
  <div style={{height:180}}></div>
 
  </div>
    );
}

export default Home;
